import React from "react";
import PrivateRoute from "../components/PrivateRoute";
import TestHome from "../pageComponents/examenes/home";

const TestHomePage = (props) => {
  return <PrivateRoute component={TestHome} {...props} />;
};

TestHome.propTypes = {};

export default TestHomePage;
